module.exports = __webpack_public_path__ + "Roboto-Black.2b8d6922c2c9957356bc.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Black.woff2
// module id = 122
// module chunks = 16